import React, { FC } from 'react';
import dynamic from 'next/dynamic';

const MainPage = dynamic(async () => import('../components/pages/MainPage/main-page.component'));

const Index: FC = () => <MainPage />;

export default Index;
